import { createIcon } from '@chakra-ui/react';

export const EditPencilOutline = createIcon({
  displayName: 'EditPencil',
  viewBox: '0 0 32 31.996',
  path: (
    <path
      id="Edit_Pencil_-_L-2"
      data-name="Edit Pencil - L"
      d="M25.934,10.076,6.5,29.514a.8.8,0,0,1-.345.2l-2.407.721a6.5,6.5,0,0,1-.635-.559,6.246,6.246,0,0,1-.559-.64l.741-2.4a.833.833,0,0,1,.208-.345L22.913,7.05a.754.754,0,0,0-1.066-1.066L2.4,25.427a2.351,2.351,0,0,0-.584.98L.561,30.621a1.447,1.447,0,0,0,1.8,1.8l4.22-1.259a2.31,2.31,0,0,0,.98-.584L27,11.143a.754.754,0,1,0-1.066-1.066Zm6.3-5.408L28.316.748a.894.894,0,0,0-1.259,0l-3.6,3.605,5.169,5.169,3.61-3.6a.878.878,0,0,0,0-1.254Z"
      transform="translate(-0.499 -0.489)"
      fill="currentColor"
    />
  ),
});

export const EditPencilSolid = createIcon({
  displayName: 'EditPencil',
  viewBox: '0 0 16 16',
  path: (
    <path
      id="Edit_Pencil_-_S-2"
      data-name="Edit Pencil - S"
      d="M1.225,13.262a.684.684,0,0,0-.189.364L.512,15.968a.451.451,0,0,0,.538.524L3.394,16a.64.64,0,0,0,.349-.218L13.827,5.724,11.281,3.178ZM16.374,2.537,14.467.631a.422.422,0,0,0-.611,0L12.11,2.377l2.517,2.517,1.746-1.746a.422.422,0,0,0,0-.611Z"
      transform="translate(-0.505 -0.5)"
      fill="currentColor"
    />
  ),
});
